<mds-card [appearance]="'outlined'">
    <mds-card-content>
        @if (mode === 'view') {
            <div class="o-grid">
                <div class="o-grid__row">
                    <div class="o-grid__item">
                        <h5>Transfer {{ index + 1 }}</h5>
                    </div>
                </div>
                <div class="o-grid__row" data-cy="transfer-datetime">
                    <div class="o-grid__item">
                        <div class="c-info__block">
                            <h5>Pickup Date</h5>
                            <span>{{
                                formGroup.controls.pickupDate.value !== null
                                    ? (formGroup.controls.pickupDate.value.toDate() | dateFormat | uppercase)
                                    : 'Unspecified'
                            }}</span>
                        </div>
                    </div>
                    <div class="o-grid__item">
                        <div class="c-info__block">
                            <h5>Pickup Time</h5>
                            <span>{{
                                formGroup.controls.pickupTime.value !== null
                                    ? (minutesSinceMidnightToMoment(formGroup.controls.pickupTime.value).toDate()
                                      | dateFormat: 'shortTime')
                                    : 'Unspecified'
                            }}</span>
                        </div>
                    </div>
                </div>
                <div class="o-grid__row" data-cy="transfer-address">
                    <div class="o-grid__item">
                        <div class="c-info__block">
                            <h5>Pick-up Address</h5>
                            <span>{{ formGroup.controls.pickupAddress.value }}</span>
                        </div>
                    </div>
                    <div class="o-grid__item">
                        <div class="c-info__block">
                            <h5>Dropoff address</h5>
                            <span>{{ formGroup.controls.dropoffAddress.value }}</span>
                        </div>
                    </div>
                </div>
            </div>
        } @else if (mode === 'edit') {
            <div class="flex flex-col gap-medpace-field p-medpace">
                <div class="flex justify-between">
                    <h5>Transfer {{ index + 1 }}</h5>
                    <mds-icon-button
                        [icon]="'delete'"
                        (clickEvent)="remove()"
                        [tooltip]="'Delete'"
                        class="danger outline"
                    ></mds-icon-button>
                </div>
                <div class="grid grid-cols-2 gap-medpace-field">
                    <medpace-datepicker
                        data-cy="transfer-date"
                        [label]="'Pick-up Date'"
                        [appearance]="'fill'"
                        [formCtrl]="formGroup.controls.pickupDate"
                        [appearance]="'outline'"
                    />
                    <mds-dropdown
                        [closeOnPageScroll]="false"
                        data-cy="transfer-time"
                        [appearance]="'fill'"
                        [label]="'Pick-up Time'"
                        [placeholder]="'Select Time'"
                        [options]="timeOptions"
                        [formCtrl]="formGroup.controls.pickupTime"
                        [appearance]="'outline'"
                    />
                </div>
                <mds-text-field
                    #pickupAddress
                    appGoogleMapsAutocomplete
                    (placeChangeEvent)="googleMapsAutocompletePlaceChange($event, formGroup.controls.pickupAddress)"
                    data-cy="transfer-pick-up-address"
                    [label]="'Pick-up Address'"
                    [formCtrl]="formGroup.controls.pickupAddress"
                    [appearance]="'outline'"
                />
                <mds-text-field
                    #dropoffAddress
                    appGoogleMapsAutocomplete
                    (placeChangeEvent)="googleMapsAutocompletePlaceChange($event, formGroup.controls.dropoffAddress)"
                    data-cy="transfer-drop-off-address"
                    [label]="'Drop-off Address'"
                    [formCtrl]="formGroup.controls.dropoffAddress"
                    [appearance]="'outline'"
                />
            </div>
        }
    </mds-card-content>
</mds-card>
